<template>
  <article>
    <section class="section">
      <h1
        class="mb-[24px] text-center font-roboto text-[32px] font-medium leading-6 text-specialprojectsection"
      >
        Лента времени
      </h1>
      <CommonComplexFiltering
        :key="isAnyFiltersActive"
        class="mb-[20px]"
        is-timeline
        :is-initial-value="selectedCentury"
        :centuries-list="centuryList"
        :filters-active="filters"
      />
      <div class="mb-14 md:container">
        <TimeLineViewTimeLineType
          :items="timeline?.data?.value"
          @reset-scroll="handleHorizontalScrollClick(0)"
        />
      </div>
    </section>
    <CommonBlocksPageFooterBlocks />
  </article>
</template>

<script setup>
const route = useRoute();

const filters = computed(() => {
  return {
    century: route.query?.century,
    start_year: route.query?.start_year,
    end_year: route.query?.end_year,
  };
});
const { timeline } = useTimeline({ filters, per_page: 9 });

const isAnyFiltersActive = computed(() => Object.values(route.query).length);

const RomeCenturies = [
  'I',
  'II',
  'III',
  'IV',
  'V',
  'VI',
  'VII',
  'VIII',
  'IX',
  'X',
  'XI',
  'XII',
  'XIII',
  'XIV',
  'XV',
  'XVI',
  'XVII',
  'XVIII',
  'XIX',
  'XX',
];
const selectedCentury = 19;
// const selectedYears = [1800, 1899];

const centuryList = computed(() => {
  const arr = new Array(17);
  arr.fill('');
  return arr.map((_, index) => {
    const century = +index + 4;
    return {
      id: century,
      label: `${RomeCenturies[century - 1]} век`,
    };
  });
});

const handleHorizontalScrollClick = (type) => {
  const slider = document.querySelector('.timeline-slider');

  if (type === 0) {
    slider.style.right = 0;
    return;
  }

  const position = parseInt(getComputedStyle(slider).right, 10);
  const slideDirection = 500 * type;
  slider.style.right = `${position + slideDirection}px`;
};

useHead({
  title:
    'Лента времени: события, произошедшие в Истории России на полотне времени',
  meta: [
    {
      hid: 'description',
      name: 'description',
      content:
        'Удобный формат представления информации о произошедшем в российской истории. Просто выбирайте интересующий вас промежуток годов и изучайте все, что произошло тогда',
    },
  ],
  link: [
    {
      rel: 'canonical',
      href: `${useHostApp()}${route.path}`,
    },
  ],
});
</script>

<style lang="scss">
:root {
  --slider-tooltip-bg: #a4031f;
}
</style>
